import RegionalInsuranceList from "@components/Pricing/RegionalInsuranceList/RegionalInsuranceList";
import {useTranslation} from "@i18n/client";
import React from "react";
import Faq from "src/components/v5/Faq/Faq";
import useInsurancePricingConstants from "src/constants/InsurancePricingConstants";

import {CarbonPage} from "../CarbonPage";
import {supportLink} from "../components/_common/_constants";
import Layout from "../components/v5/Layout";
import {NavTheme} from "../components/v5/Nav/types";
import Billing from "../components/v5/Pricing/Billing";
import Header from "../components/v5/Pricing/Header";
import TestimonialSlider from "../components/v5/TestimonialSlider";
import {PriceRegionWithPrice} from "../constants/regionsByPricingRegionName";
import {getHostWithProtocol} from "../utils/getHostWithProtocol";
import {withLocaleServerSideProps} from "@i18n/pages";

type Props = {
  allPrices: PriceRegionWithPrice[];
};

const InsurancePricing: CarbonPage<Props> = ({allPrices}) => {
  const i18n = useTranslation();
  const {faq} = useInsurancePricingConstants();

  return (
    <Layout
      pageTitle={i18n.t(
        "Insurance & Pricing | Accepting All Major Insurance Providers | Carbon Health",
      )}
      pageDescription={i18n.t(
        "Carbon Health aims to make health high-quality healthcare accessible to all. We accepts all major insurance providers including medicare, cash payments, FSA & HSA.",
      )}
      pageImage="insurance-pricing-05032022"
      navTheme={NavTheme.LIGHT}
    >
      <Header />
      <RegionalInsuranceList allPrices={allPrices} />
      <Faq
        className="maxw75-f"
        faq={faq}
        header={i18n.t("Questions about insurance & pricing")}
        supportLink={`${supportLink}/main-categories/billing-insurance`}
      />
      <Billing />
      <TestimonialSlider />
    </Layout>
  );
};

export const getServerSideProps = withLocaleServerSideProps<Props>(async ({req}) => {
  const allPrices = await fetch(`${getHostWithProtocol(req)}/api/prices`).then(r => r.json());
  return {props: {allPrices}};
});

export default InsurancePricing;
